import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store";
import { deleteUser, getUsers } from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    users: state.usersReducer.users,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getUsers,
      deleteUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
